// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Qk9rL","content":"styles_content__2ticI","tableWrap":"styles_tableWrap__3ijvi"};